import React from 'react'
import {
  CHeader,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
} from '@coreui/react'

import {
  HeaderDropdown,
} from './index'

const Header = (props) => {

  return (
    <CHeader withSubheader>
      <div className="logo"/>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CHeaderNavItem className="px-3">
          <CHeaderNavLink to="/dashboard">Search</CHeaderNavLink>
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav className="px-3">
        <HeaderDropdown />
      </CHeaderNav>
    </CHeader>
  )
}

export default Header;
